export default __webpack_public_path__ + "static/dr-1-lg-df9e5102c0f56f1a6fc8bd3cdf2fa949.png";